import 'uni-pages';wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import App from './App'


import Vue from 'vue'
Vue.config.productionTip = false
App.mpType = 'app'
const app = new Vue({
    ...App
})
app.$mount()